import axios from "axios";
import { createAxiosInstance } from "@moodys/mdc-frontend.services.fetcher";
export const isHostMDC = () => window.location?.host?.indexOf("moodys.com") >= 0;
export const isHostPrdMDC = () => window.location?.host === "www.moodys.com";
export const axiosClient = createAxiosInstance({
    baseURL: "/shared/api",
});
export const isTruthyString = (s) => typeof s !== "undefined" &&
    (typeof s === "string" || s instanceof String) &&
    s.trim().length > 0;
export const getLogMessage = (params) => {
    const { message, ...rest } = params ?? {};
    return {
        message,
        ...rest,
    };
};
export const getErrorLog = (params) => {
    const { error, message, ...rest } = params;
    if (axios.isAxiosError(error)) {
        const logMessage = message || error?.message || "Axios Error";
        return {
            ...getLogMessage(rest),
            errorMessage: error?.message,
            ...error,
            message: logMessage,
        };
    }
    else if (error instanceof Error) {
        const logMessage = message || error?.message || "Error occurred";
        return {
            ...getLogMessage(rest),
            errorMessage: error?.message,
            ...error,
            message: logMessage,
        };
    }
    else if (isTruthyString(error)) {
        const logMessage = message || error || "Error occurred";
        return {
            ...getLogMessage(rest),
            message: logMessage,
            errorMessage: error,
        };
    }
    else {
        return getLogMessage(params);
    }
};
export const callFrontEndLogger = (log) => {
    if (isHostMDC()) {
        // To make the frontend logger API call truly asynchronous,
        // it is a promise that does nothing when it returns
        axiosClient
            .post("/front-end-logger", log)
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .then(() => { })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => { });
    }
    else if (!isHostPrdMDC()) {
        // eslint-disable-next-line no-console
        console[log.level](log);
    }
};
export const debug = (params, metadata) => {
    callFrontEndLogger({
        level: "debug",
        log: getLogMessage(params),
        metadata,
    });
};
export const info = (params, metadata) => {
    callFrontEndLogger({
        level: "info",
        log: getLogMessage(params),
        metadata,
    });
};
export const warn = (params, metadata) => {
    callFrontEndLogger({
        level: "warn",
        log: getLogMessage(params),
        metadata,
    });
};
export const error = (params, metadata) => {
    callFrontEndLogger({
        level: "error",
        log: getErrorLog(params),
        metadata,
    });
};
//# sourceMappingURL=logger.utils.js.map